export enum ValidityState {
    VALID = 0,
    WARNING = 1, // Missing cost centers only
    INVALID = 2 // Other validation failures
}
